'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.runApplication = runApplication;

var _prax = require('prax');

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

var _adblockUtils = require('./adblock/adblockUtils');

var _Settings = require('./Settings');

var _I18n = require('./I18n');

var _sentryIntegration = require('./sentryIntegration');

var _googleAnalyticsIntegration = require('./googleAnalyticsIntegration');

var _authorizationIntegration = require('./authorizationIntegration');

var _Application = require('./Application');

function runApplication(options) {
    var application = new _Application.Application(options);

    application.logger.enableAll();

    application.readiness = new _prax.Atom({ ready: false, error: null });

    application.readyPromise = initApplication(application, options).then(function () {
        application.readiness.reset({ ready: true });
        return null;
    }).catch(function (error) {
        application.readiness.reset({ ready: true, error: error });
    });

    return application;
}

function initApplication(application, options) {
    var defaultSettings = options.defaultSettings,
        settingsPath = options.settingsPath,
        overrideSettings = options.overrideSettings,
        authorizationFactory = options.authorizationFactory,
        beforeInitialRender = options.beforeInitialRender;


    _auroraJavascriptUtils.assert.func(authorizationFactory);
    _auroraJavascriptUtils.assert.func(beforeInitialRender);

    return (0, _Settings.loadSettingsWithOptionalOverride)(application, defaultSettings, settingsPath, overrideSettings).then(function (settings) {
        application.settings = settings;
    }).then(function () {
        return (0, _sentryIntegration.initializeSentry)(application);
    }).then(function () {
        return (0, _googleAnalyticsIntegration.initializeGoogleAnalytics)(application);
    }).then(function () {
        return (0, _I18n.initializeI18n)(application);
    }).then(function () {
        return (0, _authorizationIntegration.initializeAuthorization)(application, authorizationFactory);
    }).then(function () {
        return (0, _sentryIntegration.initializeSentryUserContext)(application);
    }).then(function () {
        return (0, _adblockUtils.detectAdblockAndAlert)(application);
    }).then(function () {
        return beforeInitialRender(application);
    });
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/applicationBoostrapper.js
// module id = 1312
// module chunks = 118